export default __webpack_public_path__ + "media/images/27-895c7b15ffbc032b1b9141f9db374695.jpg";